export default __webpack_public_path__ + "static/media/Mutual of Omaha Dark.83f8c1c6.svg";